import { initSentry } from "@alascorporation/observability";
import * as Sentry from "@sentry/react";

if (import.meta.env.DEV) {
  (window as typeof window & { Sentry?: typeof Sentry }).Sentry = Sentry;
}

initSentry(Sentry, {
  appName: "academy-frontend",
  dsn: import.meta.env.VITE_SENTRY_DSN,
  mode: import.meta.env.MODE,
  env: import.meta.env,
  version: import.meta.env.VITE_APP_VERSION,
});

export { Sentry };
